import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  ADD_NOTE: {
    id: 'AddCallNoteInline.ADD_NOTE',
    defaultMessage: 'Notiz hinzufügen',
  },
  ENTER_NOTE: {
    id: 'AddCallNoteInline.ENTER_NOTE',
    defaultMessage: 'Notiz eingeben...',
  },
  CANCEL: {
    id: 'AddCallNoteInline.CANCEL',
    defaultMessage: 'Abbrechen',
  },
  SAVE: {
    id: 'AddCallNoteInline.SAVE',
    defaultMessage: 'Speichern',
  },
  SAVING: {
    id: 'AddCallNoteInline.SAVING',
    defaultMessage: 'Speichert...',
  },
  ERROR_SAVING: {
    id: 'AddCallNoteInline.ERROR_SAVING',
    defaultMessage: 'Fehler beim Speichern',
  },
});

const AddCallNoteInline = ({ callId, onAddNote }) => {
  const intl = useIntl();
  const [isAdding, setIsAdding] = useState(false);
  const [value, setValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    if (!value.trim()) return;
    setIsSaving(true);
    onAddNote(callId, value).then(() => {
      setIsSaving(false);
      setIsAdding(false);
      setValue('');
    }).catch(() => {
      setIsSaving(false);
      alert(intl.formatMessage(messages.ERROR_SAVING));
    });
  };

  if (isAdding) {
    return (
      <div style={{ 
        marginTop: '12px', 
        background: 'var(--input-bg)', 
        padding: '12px', 
        borderRadius: '12px', 
        border: '1px solid var(--input-border)',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
      }}>
        <textarea
          placeholder={intl.formatMessage(messages.ENTER_NOTE)}
          style={{ 
            width: '100%', 
            minHeight: '60px', 
            padding: '8px', 
            fontSize: '13px',
            border: 'none',
            borderBottom: '2px solid transparent',
            outline: 'none',
            resize: 'vertical',
            transition: 'border-color 0.2s ease',
            backgroundColor: 'transparent',
            color: 'var(--text-color)'
          }}
          onFocus={e => e.currentTarget.style.borderBottom = '2px solid var(--primary-color)'}
          onBlur={e => e.currentTarget.style.borderBottom = '2px solid transparent'}
          value={value}
          onChange={e => setValue(e.target.value)}
          disabled={isSaving}
          autoFocus
        />
        <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button 
            className="lh-btn lh-btn-small lh-btn-default" 
            onClick={() => { setIsAdding(false); setValue(''); }}
            disabled={isSaving}
            style={{ height: '34px', boxSizing: 'border-box' }}
          >
            {intl.formatMessage(messages.CANCEL)}
          </button>
          <button 
            className="lh-btn lh-btn-small lh-btn-primary" 
            onClick={handleSave}
            disabled={isSaving || !value.trim()}
            style={{ height: '34px', boxSizing: 'border-box' }}
          >
            {isSaving ? intl.formatMessage(messages.SAVING) : intl.formatMessage(messages.SAVE)}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <button 
        onClick={() => setIsAdding(true)}
        className="lh-btn lh-btn-small lh-btn-default"
        style={{ height: '34px', boxSizing: 'border-box' }}
      >
        <i className="fa fa-plus" style={{ marginRight: '6px' }}></i>
        {intl.formatMessage(messages.ADD_NOTE)}
      </button>
    </div>
  );
};

export default AddCallNoteInline;
